import React from "react"
import {
    KlassDropdown,
    KlassDropdownAsync,
    KlassDropdownProps,
    KlassDropdownAsyncProps,
    KlassDropAsyncPaginate
} from "components/Select"
import DepartmentSubunitSelect from "components/DepartmentSubunitSelect"

export function KlassappTableDropdown(props: Partial<KlassDropdownProps>) {
    return <KlassDropdown {...props} />
}

export function KlassappTableDropdownAsyncPaginate(props: Partial<KlassDropdownAsyncProps>) {
    return <KlassDropAsyncPaginate {...props} />
}

export function KlassappTableDropdownAsync(props: Partial<KlassDropdownAsyncProps>) {
    return <KlassDropdownAsync {...props} />
}

export function KlassappTableDepartmentSubunitSelect(props: Partial<KlassDropdownAsyncProps>) {
    return <DepartmentSubunitSelect {...props} />
}
